// extracted by mini-css-extract-plugin
export default {"productcard":"gC","productimage":"hC","username":"iC","multiBagName":"jC","productinfo":"kC","productinfoinner":"lC","productname":"mC","productsubheader":"nC","productdescription":"oC","productnumbers":"pC","productnumberstitle":"qC","productnumbersitem":"rC","number":"sC","numbertext":"tC","tabs":"uC","benefitsblock":"vC","benefit":"wC","benefitname":"xC","benefitdescription":"yC","ingredientsblock":"zC","tipsblock":"AC","mobileonly":"BC"};
    if(module.hot) {
      // 1713211520710
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  